export interface MapsApiOpts {
	key?: string
	channel?: string
	region?: string
	language?: string
	url?: string
}

export enum MapEvents {
	loaded = 'googleMapsApiLoaded',
	error = 'googleMapsApiLoadingError',
	tilesLoaded = 'mapTilesLoaded',
}
